import axios from 'axios';
import i18n from "../i18n";
import config from "../config";

let language = i18n.language;

let baseURL = config.apiUrl;

//const baseURL = "https://beta-api.surofi.no/";

export const AxiosApi = axios.create({
    baseURL,
    //timeout: 11000, 
    withCredentials: true,
    // add custom header
    headers: {
        'Language': language,
    }
});


AxiosApi.interceptors.response.use(resp => {
    return resp
}, err => {
    if (!err.response) return Promise.reject(err);
    if(err.response?.request.status === 0) return Promise.reject(err);
    if(err.response?.request.status === 0) return Promise.reject(err);

    const { responseURL, status } = err.response?.request;
    if(!responseURL) return Promise.reject(err);
    const isRedirect = responseURL.includes("ReturnUrl") && responseURL.includes("login");
    if (isRedirect) {
        //Todo: we dont need this when we are using same site 
        // const redirect = responseURL.split("/login")[1]
        // const loginUrl = `/login/${redirect}`
        if (status === 401) {
            window.location.replace("/login");
        }
        // // Todo: remove this, this is just to handle redirect issue which wont happy when deploy 
        // if (status === 405) {
        //     window.location.replace("/login");
        // }
    }
     
    return Promise.reject(err);
});

